import injectionCode from '../../../preview/standard-checkout'

const type = 'standard'
const path = '/standard/angular-node/client/src/app/'
const name = 'app.component.ts'

export { type, path, name, injectionCode }
